/*
* Copyright (c) Trainline Limited, 2017. All rights reserved.
* See LICENSE.txt in the project root for license information.
*/

export const black = '#191B1F';
export const white = '#FFFFFF';

export const mint = '#01C3A7';
export const fern = '#14B69F';
export const ivy = '#059E87';
export const pond = '#D3F9F4';
export const gin = '#EEFFFD';

export const snow = '#F2F4F7';
export const navy = '#21314D';

export const darth = '#13181A';
export const moria = '#323E42';
export const slate = '#647479';
export const storm = '#8C9DA1';
export const steel = '#C0C9CC';
export const marble = '#DCE3E6';

export const sky = '#4B96F8';
export const marine = '#3F618C';

export const kevin = '#FFBD24';
export const canary = '#FFE94A';

export const dover = '#E6F4FC';
export const delta = '#0375B6';
export const peach = '#FFEAD9';
export const fox = '#E87619';
export const rose = '#FCE8E6';
export const sam = '#E02007';

export const lichen = '#F2F8EC';
export const leaf = '#90C25B';


// WEBPACK FOOTER //
// ./colors.ts